<script setup lang="ts">
import { ChatIcon } from 'assets/data/icons';
const colorMode = useColorMode();
const fillValue = computed(() => {
  return colorMode.value === 'dark'
    ? 'url(#light-gradient)'
    : 'url(#dark-gradient)';
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    :class="fillValue"
  >
    <path :d="ChatIcon" :fill="fillValue" />
  </svg>
</template>
<style scoped></style>
